import { ResultType, VehicleType } from "../../../../modules/home/pages/RevisioniPage/constants/constants";

// 6. HOME PAGE
const HOME_PAGE_TEXT = {
    PAGE_TITLE: "Titolo SPA Template",
    PAGE_DESCRIPTION: "Seleziona un'operazione",
    MAIN_BTN_LABEL_NEW_PROCESS: "Bottone primario 1",
    MAIN_BTN_LABEL_MANAGEMENT_FILE: "Bottone primario 2",
    MAIN_BTN_LABEL_PAPERWORKS_HISTORY: "Bottone primario 3",
};

// 6.1. Nuova Lavorazione
const NEW_PROCESS_PAGE_TEXT = {
    PAGE_TITLE: "Titolo",
    PAGE_DESCRIPTION:
        "Lorem, ipsum dolor sit amet consectetur adipisicing elit.", // TODO: The description is WIP
    FORM_INSTANCE_FORMAT: "Radio button",
    FORM_PAPERWORK_TYPE: "Select",
    FORM_LICENSE_PLATE: "Input",
    FORM_LICENSE_PLATE_PLACEHOLDER: "Inserire il campo",
};

//REVISIONI 
const REVISIONI_TEXT = {
    HEADER_PAGE_TITLE: "Revisioni",
    HEADER_BUTTON_TITLE: "Torna al portale dell’automobilista",
    HEADER_PORTALE_AUTOMOBILISTA_URL: "https://www.ilportaledellautomobilista.it/web/portale-automobilista/home",
    HEADER_MINISTERO_TRASPORTI_URL: "https://www.mit.gov.it/",
    APP_BODY_TITLE: "Ricerca le revisioni effettuate dopo il 1 Giugno 2018",
    PLATE_FIELD_PLACEHOLDER: "Targa",
    VEHICLE_TYPE_FIELD_PLACEHOLDER: "Tipologia veicolo*",
    CLEAR: "Svuota Ricerca",
    SEARCH: "Avvia Ricerca",
    ENTER_CAPTCHA_TITLE: "Digita la parola mostrata in figura e clicca su \"Valida\".",
    ENTER_CAPTCHA_TEXTFIELD_PLACEHOLDER: "Inserire il captcha",
    VALIDATE_CAPTCHA: "Valida",
    CHANGE_CAPTCHA_IMG: "Cambia immagine",
    UNABLE_RETRIEVE_IMAGE_PLACEHOLDER: "Impossibile recuperare l'immagine.",
    CAPTCHA_VALIDATION_SUCCESS_MESSAGE: "Captcha validato con successo",
    EMPTY_TABLE_PLACEHOLDER: "Nessun dato disponibile",
    EXTRAMASSA_DESCRIPTION: "Esito verifica massa supplementare",
    PLATE_NOT_FOUND: "Targa non associata a veicolo circolante",
    NO_INSPECTIONS_FOUND: "Per il veicolo selezionato non risultano revisioni effettuate dopo il 1 giugno 2018",
    INVALID_PLATE: "La targa del veicolo non è valida",
    INVALID_PLATE_ERROR_CODE: "Inserimento targa KO",
    INVALID_CICLOMOTORE_PLATE_ERROR_MSG: "La lunghezza della Targa deve essere tra 6 e 8 caratteri",
    INVALID_PLATE_ERROR_MSG: "La lunghezza della Targa deve essere tra 7 e 8 caratteri",
    INVALID_TYPE: "La tipologia di veicolo non è valida",
    INVALID_TYPE_ERROR_CODE: "Inserimento tipologia veicolo KO",
    INVALID_TYPE_ERROR_MSG: "La tipologia del veicolo non è stata selezionata",
    INVALID_CAPTCHA_ERROR_CODE: "Validazione Captcha Obbligatoria",
    INVALID_CAPTCHA_ERROR_MSG: "E' necessario procedere con la validazione captcha prima di confermare la ricerca",
    CAPTCHA_VALIDATION_ERROR_CODE: "Ops, qualcosa non va ...",
    CAPTCHA_VALIDATION_ERROR_MSG: "Validazione captcha fallita. Si prega di digitare il captcha prima di validare l'inserimento", 
    FETCH_VEICLE_DATA_ERROR_CODE: "Ops, qualcosa non va ...",
    FETCH_VEICLE_DATA_ERROR_MSG: "Errore nel caricamento dei dati. Si prega di riprovare",
    RESULTS_HEADING: "Tutti i risultati",
    RESULTS_MODAL_BTN_TITLE: "Nota bene",
    RESULTS_INFO_TITLE_FIRST: "Tipologia veicolo",
    RESULTS_INFO_TITLE_SECOND: "Targa ricercata",
    TABLE_HEADING_FIRST_FIELD: "Data revisione",
    TABLE_HEADING_SECOND_FIELD: "Esito revisione",
    TABLE_HEADING_THIRD_FIELD: "Km rilevati dall’operatore",
    MODAL_TEXT_TITLE: "Nota Bene",
    MODAL_TEXT_MESSAGE: "Si rende noto che il numero dei chilometri totali percorsi dal veicolo, riportati nella colonna 'km rilevati dall'operatore', è un dato che viene rilevato manualmente dalla strumentazione di bordo dall'operatore che esegue la revisione del veicolo. \n Poichè dal 1° giugno 2018, in caso di esito positivo delle verifiche, tale dato viene riportato anche sull'attestato di revisione, è esclusiva responsabilità dell'utente verificare il dato inserito appena ricevuto il predetto attestato e, in caso di errore, chiederne l'immediata rettifica all'operatore che ha eseguito la revisione. \n Ne consegue che una volta concluso il processo di revisione ed aggiornati gli archivi, la Motorizzazione, non potrà apportare alcuna modifica ai dati nè, tantomeno, accettare richieste in tal senso, anche se supportate da attestazioni sottoscritte dalla struttura presso la quale è stata effettuata la revisione. \n In tal modo, la successione storica dei dati di revisione (che verrà resa disponibile solo agli utenti registrati e per le operazioni effettuate successivamente al 1° giugno 2018), compreso il chilometraggio complessivo, risulterà verificata dagli utenti stessi e, pertanto, maggiormente affidabile ai fini della conoscenza sullo stato del veicolo e della relativa percorrenza complessiva.",
    TABLE_HEADING_TARGA: "Targa alla revisione"
};

// RESULTS ERROR MESSAGES
const REVISIONI_ERROR_MESSAGES = {
    _404: "Informazione non disponibile",
    _496: "Ciclomotore/Minicar non trovate",
    _497: "Targa non associata a Ciclomotore/Minicar circolante",
    _498: "Targa non associata a veicolo circolante",
    _499: "Per il veicolo selezionato non risultano revisioni effettuate dopo il 1 giugno 2018",
}

// RESULTS LABELS
const RESULTS_LABELS = [
    {
        label: "SOSPENDERE",
        value: ResultType.SOSPENDERE
    },
    {
        label: "REGOLARE",
        value: ResultType.REGOLARE
    },
    {
        label: "RIPETERE",
        value: ResultType.RIPETERE
    }
];

const VEHICLE_TYPES = [
    {
        label: "AUTOVEICOLO",
        value: VehicleType.AUTOVEICOLO
    },
    {
        label: "CICLOMOTORE",
        value: VehicleType.CICLOMOTORE
    },
    {
        label: "MOTOVEICOLO",
        value: VehicleType.MOTOVEICOLO
    },
    {
        label: "RIMORCHIO",
        value: VehicleType.RIMORCHIO
    }
];

const ACTION_BAR_BUTTONS_TEXT = {
    EXIT: "Chiudi",
    CANCEL: "Annulla",
    RESET: "Reset",
    CONFIRM: "Conferma",
    TO_BACK: "Indietro",
    SEND: "Invia",
};

const COMPONENTS_TEXT = {
    DROPDOWN_COMPONENT_PLEASE_CHOOSE_ONE_OPTION: "Scegliere un'azione",
    SELECT_COMPONENT_NO_DATA_AVAILABLE: "Nessun dato trovato",
    SELECT_COMPONENT_LOADING: "Caricamento...",
    SELECT_COMPONENT_ERROR: "Errore",
    TABLE_MISSING_DATA: "Nessun Dato presente nella Tabella",
    SUCCESS_MSG: "Operazione eseguita correttamente",
};

const LAYOUT_TEXT = {
    LOGO_LABEL: "Titolo SPA Template",
    ROUTE_LBL_HOME: "Home",
    ROUTE_LBL_NEW_PROCESS: "Menu",
    ROUTE_LBL_DIRECTORY_MANAGEMENT: "Gestione Fascicoli",
    ROUTE_LBL_PAPERWORKS_HISTORY: "Storico Pratiche",
    ROUTE_LBL_CONSULTATION: "Consultazioni",
    ROUTE_LBL_SEARCH_INSTANCE: "Bottone secondario",
    ROUTE_LBL_END_OF_DAY: "Bottone secondario",
    ROUTE_LBL_CERTIFICATION: "Bottone secondario",
    ROUTE_LBL_PAYMENT_CONSULTATION: "Bottone secondario",
    FOOTER_ROUTE_LBL_PRIVACY_POLICY: "Privacy Policy",
    FOOTER_ROUTE_LBL_LEGAL_NOTICES: "Note Legali",
    FOOTER_ROUTE_LBL_MEDIA_POLICY: "Media Policy",
    FOOTER_ROUTE_LBL_CONTACTS: "Contatti",
    FOOTER_ROUTE_LBL_ACCESSIBILITY: "Accessibilità",
    FOOTER_ROUTE_LBL_ASSISTANCE: "Assistenza",
};

const MESSAGE_VALIDATION_FIELD = {
    REQUIRED: "The field is required",
    MINLENGTH: "Insert the minimum lunge",
    MIN: "Insert a value valid",
    MAX: "Insert a value valid",
};

export {
    HOME_PAGE_TEXT,
    NEW_PROCESS_PAGE_TEXT,
    ACTION_BAR_BUTTONS_TEXT,
    COMPONENTS_TEXT,
    RESULTS_LABELS,
    VEHICLE_TYPES,
    REVISIONI_ERROR_MESSAGES,
    LAYOUT_TEXT,
    MESSAGE_VALIDATION_FIELD,
    REVISIONI_TEXT,
};
